import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, EventEmitter, input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PhoneFormatPipe } from '../../../pipes/phone-format.pipe';

@Component({
  selector: 'app-form-input',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  providers: [PhoneFormatPipe],
  templateUrl: './form-input.component.html',
  styleUrl: './form-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputComponent implements OnInit {
  readonly label = input<string>('');
  readonly typeInput = input<string>('');
  readonly fieldName = input<string>('');
  readonly labelErrorName = input<string>('');
  readonly generateIdButton = input<boolean>(false);
  readonly onlyNumberInputs = input<boolean>(false);
  readonly preValue = input<string>('');
  readonly isRequired = input<boolean>(false);
  readonly hasMinLength = input<boolean>(false);
  readonly isDisabled = input<boolean>(false);
  readonly maxLength = input<number>(0);
  readonly isPhoneOrNif = input<boolean>(false);
  readonly onlyUpperCase = input<boolean>(false);

  @Output() readonly onDataChanged = new EventEmitter<string>();

  showError = false;
  labelError = '';
  showPassword = false;

  touched = false;
  currentValue = '';

  constructor(
    private phonePipe: PhoneFormatPipe,
    private cdr: ChangeDetectorRef
  ) {
    effect(() => {
      const newValue = this.preValue() || '';
      if (this.isPhoneOrNif()) {
        const clean = newValue.replace(/\D/g, '').substring(0, 9);
        this.currentValue = clean.match(/.{1,3}/g)?.join(' ') || '';
      } else {
        this.currentValue = newValue;
      }
      this.isRequired();

      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    this.currentValue = this.preValue();

    if (this.fieldName() === 'formName')
    {
      this.labelError = this.labelErrorName() ? this.labelErrorName() : this.label();
      return;
    }
    this.labelError = this.labelErrorName() ? this.labelErrorName() : this.fieldName();

    const initialValue = this.preValue();
    this.currentValue = this.isPhoneOrNif() ? this.phonePipe.transform(initialValue) : initialValue;
  }

  onInputChange(event: Event): void {
    let value = (event.target as HTMLInputElement).value;

    if (this.isPhoneOrNif()) {
      let rawValue = value.replace(/\D/g, '');

      if (rawValue.length > 9) {
        rawValue = rawValue.substring(0, 9);
      }

      let formatted = rawValue.match(/.{1,3}/g)?.join(' ') || '';

      this.currentValue = formatted;
      (event.target as HTMLInputElement).value = formatted;

      this.onDataChanged.emit(rawValue);
    } else if (this.onlyNumberInputs()) {
      value = value.replace(/[^0-9]/g, '');
      (event.target as HTMLInputElement).value = value;
      this.currentValue = value;
      this.onDataChanged.emit(value);
    } else {
      if (this.onlyUpperCase()) {
        value = value.toUpperCase();
      }
      this.currentValue = value;
      this.onDataChanged.emit(value);
    }
  }

  onBlur(): void {
    this.showError = (this.isRequired() && !this.currentValue.trim()) ||
                     (this.hasMinLength() && !this.currentValue.trim());
  }
}
